/* eslint-disable @typescript-eslint/no-explicit-any */
import { THEME } from '@common/constants/theme.constant';
import { getNow } from '@common/utils/get-now/now.util';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { css } from 'twin.macro';

export const LayoutFooter = (): JSX.Element => {
    const { i18n } = useTranslation();
    const handleChangeLanguageHandler = (lang: string): void => {
        i18n.changeLanguage(lang);
        window.location.reload();
    };

    const isCookieControlAvailable = (): boolean => {
        return (window as any)?.CookieControl !== undefined;
    };
    return (
        <div css={styles.root}>
            <div tw="hidden">
                <span onClick={(): void => handleChangeLanguageHandler('en')} tw="cursor-pointer">
                    en
                </span>
                &nbsp;|&nbsp;
                <span onClick={(): void => handleChangeLanguageHandler('de')} tw="cursor-pointer">
                    de
                </span>
            </div>
            © {getNow().getFullYear()} Oddbox Delivery Ltd. Registered in England No. 9638976. {isCookieControlAvailable() ? <span tw='underline cursor-pointer' onClick={(window as any)?.CookieControl.open}>Manage Cookies</span> : null}
        </div>
    );
};
const styles = {
    root: css`
        background: ${THEME.WHITE};
        padding: 16px;
        text-align: center;
        font-size: 14px;
        border-top: 1px solid ${THEME.GRAY_100};
    `,
};
